var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "addresses"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("Addresses")]), [_c('div', {
    staticClass: "bar"
  }, [_c('p', {
    staticClass: "count"
  }, [_vm._v(" " + _vm._s(_vm.totalAddresses.toLocaleString()) + " " + _vm._s(_vm._f("pluralize")(_vm.totalAddresses, 'address')) + " found ")])])]], 2), _vm.loading && !_vm.assetsLoaded ? [_c('v-progress-circular', {
    key: "1",
    attrs: {
      "size": 16,
      "width": 2,
      "color": "#E84970",
      "indeterminate": ""
    }
  })] : [_c('AddressDataTable', {
    attrs: {
      "addresses": _vm.addressesList,
      "links": true
    }
  })]], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }